module.exports = __webpack_public_path__ + "img/ellipsis.4bffc2c0.svg";